import React from 'react';
import { Box, Typography, Button, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook

const LandingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(3),
}));

const TextAndImageSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const TextContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginRight: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
    textAlign: 'center',
  },
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginTop: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
}));

function LandingSection() {
  const navigate = useNavigate(); // Instantiate the navigate function

  return (
    <LandingContainer>
      <TextAndImageSection>
        <TextContent>
          <Typography variant="h3" component="h1" gutterBottom>
            Realigning Technology to Enhance the Consumer Experience.
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Experience Based Innovation differentiates yourself in the eyes of the consumer by the experience you provide, not just by the services you offer.
          </Typography>
        </TextContent>
        <img src="/assets/JET_stacked_color 480 x 480-01.jpg" alt="New Logo" style={{ marginTop: 16, maxWidth: '100%', height: 'auto' }} />
      </TextAndImageSection>
      <Typography variant="h6" gutterBottom style={{ marginTop: 16, textAlign: 'center' }}>
        Our innovation offers a unique and comprehensive experience to pique interest.
      </Typography>
      <ButtonContainer>
        <StyledButton variant="contained" onClick={() => navigate('/consumerengagement')}>CONSUMER ENGAGEMENT</StyledButton>
        <StyledButton variant="contained" onClick={() => navigate('/clientacquisition')}>CLIENT ACQUISITION & LEAD MANAGEMENT</StyledButton>
        <StyledButton variant="contained" onClick={() => navigate('/portfolioretention')}>PORTFOLIO RETENTION</StyledButton>
        <StyledButton variant="contained" onClick={() => navigate('/exclusiveleads')}>EXCLUSIVE LEADS</StyledButton>
      </ButtonContainer>
    </LandingContainer>
  );
}

export default LandingSection;
